import React, { useState, useEffect } from "react";
import { Button, Typography, Box } from "@mui/material";
import api from "../../../services/api";

import GrazeBoxTable from "./GrazeBoxTable";
import GrazeBoxFormModal from "./GrazeBoxFormModal";

const GrazeBoxes = () => {
  const [grazeBoxes, setGrazeBoxes] = useState([]);
  const [selectedBox, setSelectedBox] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchGrazeBoxes();
  }, []);

  const fetchGrazeBoxes = async () => {
    try {
      const response = await api.get("/graze-boxes");
      setGrazeBoxes(response.data);
    } catch (error) {
      console.error("Error fetching graze boxes:", error);
    }
  };

  const handleDelete = async (box) => {
    try {
      await api.delete(`/graze-boxes/${box._id}`);
      setGrazeBoxes((prev) => prev.filter((b) => b._id !== box._id));
    } catch (error) {
      console.error("Error deleting graze box:", error);
    }
  };

  const handleSave = async (formData) => {
    try {
      if (formData._id) {
        console.log("hereeee");
        await api.put(`/graze-boxes/${formData._id}`, formData);
      } else {
        await api.post("/graze-boxes", formData);
      }
      fetchGrazeBoxes();
    } catch (error) {
      console.error("Error saving graze box:", error);
    }
  };

  return (
    <Box sx={{ padding: "1rem" }}>
      <Typography variant="h4" gutterBottom>
        Manage Graze Boxes
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          setSelectedBox(null);
          setIsModalOpen(true);
        }}
        sx={{ mb: 2 }}>
        Add Graze Box
      </Button>

      <GrazeBoxTable
        grazeBoxes={grazeBoxes}
        onDelete={handleDelete}
        onEdit={(box) => {
          setSelectedBox(box);
          setIsModalOpen(true);
        }}
      />

      {isModalOpen && (
        <GrazeBoxFormModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSave={handleSave}
          initialData={selectedBox}
        />
      )}
    </Box>
  );
};

export default GrazeBoxes;
